export class CustomerDeliveryAddress {
  public id?: number;
  public fullName?: string;
  public phoneNumber?: string;
  public email?: string;
  public country?: string;
  public city?: string;
  public street?: string;
  public houseNumber?: string;
  public zipCode?: string;
}
